<template>
  <div class="foot-box"
       v-if="initConfig.serviceName">
    <img
      fetchpriority="high"
      :src="require('@/assets/img/tvu_logo.png')"
      alt="">
    <span>{{ $t('copyright') }} © TVU Networks</span>
    <a
      href="https://www.tvunetworks.com/company-terms-and-conditions/"
      target="blank">{{ $t('terms') }}</a>
    <a
      href="https://www.tvunetworks.com/company-privacy-notice/"
      target="blank">{{ $t('policy') }}</a>
    <a
      href="https://www.tvunetworks.com/company-content-license-agreement/"
      target="blank">{{ $t('license') }}</a>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: 'foot-page',
  computed: {
    ...mapState({
      initConfig: 'initConfig'
    })
  }
}
</script>
